import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "openIcon", "closeIcon"];

  connect() {
    // S'assurer que le dropdown est fermé au chargement
    this.contentTarget.classList.add("hidden");

    // Ajouter un gestionnaire d'événement pour les clics en dehors du dropdown
    document.addEventListener("click", this.handleDocumentClick.bind(this));
  }

  disconnect() {
    // Nettoyer l'écouteur d'événement quand le contrôleur est déconnecté
    document.removeEventListener("click", this.handleDocumentClick.bind(this));
  }

  toggle(event) {
    // Empêcher la propagation pour éviter que clickOutside ne se déclenche immédiatement
    if (event) {
      event.stopPropagation();
    }

    // Toggle du contenu dropdown
    this.contentTarget.classList.toggle("hidden");

    // Alterner les icônes open/close
    this.openIconTarget.classList.toggle("hidden");
    this.closeIconTarget.classList.toggle("hidden");
  }

  handleDocumentClick(event) {
    // Si le dropdown est ouvert et que le clic est en dehors du dropdown
    if (
      !this.contentTarget.classList.contains("hidden") &&
      !this.element.contains(event.target)
    ) {
      this.toggle();
    }
  }
}
